import { memo } from "react";

const TableMenu = memo(({ color }) => {
  return (
    <svg height="2.8vh" viewBox="0 0 30 30" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path d="M3.75 2.5H6.25V27.5H3.75V2.5ZM12.5 7.5H21.25V10H12.5V7.5ZM12.5 12.5H21.25V15H12.5V12.5Z" fill={color} />
      <path d="M23.75 2.5H7.5V27.5H23.75C25.1287 27.5 26.25 26.3787 26.25 25V5C26.25 3.62125 25.1287 2.5 23.75 2.5ZM23.75 25H10V5H23.75V25Z" fill={color} />
    </svg>
  );
});
export default TableMenu;
